<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
    <div *ngFor="let category of cableCategories">
        <div *ngIf="electricalCablesSubCollection(category).length" style="page-break-inside: avoid">
            <h5>{{category}}</h5>
            <table class="optionalComponentSectionTable">
                <tr style="font-weight: bold;">
                    <td style="text-align:left;padding-right:5px;">Current Type</td>
                    <td style="text-align:right;padding-right:5px;">Length (km)</td>
                    <td style="text-align:right;padding-right:5px;">Voltage (kV)</td>
                    <td style="text-align:left;padding-right:5px;">Terrain</td>
                </tr>
                <tr *ngFor="let ec of electricalCablesSubCollection(category)">
                    <td>{{ec.electricalCurrentType}}</td>
                    <td style="text-align:right;padding-right:5px;">{{ec.lengthKm}}</td>
                    <td style="text-align:right;padding-right:5px;">{{ec.voltageKv}}</td>
                    <td>
                        <span *ngIf="ec.isOnshore">onshore</span>
                        <span *ngIf="ec.isOnshore && ec.isOffshore"> and </span>
                        <span *ngIf="ec.isOffshore">offshore</span>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>

<ng-template #template_mobile let-title="title">
    <div *ngFor="let category of cableCategories">
        <div *ngIf="electricalCablesSubCollection(category).length" style="page-break-inside: avoid">
            <h5>{{category}}</h5>
            <table class="optionalComponentSectionTable">
                <tr style="font-weight: bold;">
                    <td style="text-align:left;padding-right:5px;">Current Type</td>
                    <td style="text-align:right;padding-right:5px;">Length (km)</td>
                    <td style="text-align:right;padding-right:5px;">Voltage (kV)</td>
                    <td style="text-align:left;padding-right:5px;">Terrain</td>
                </tr>
                <tr *ngFor="let ec of electricalCablesSubCollection(category)">
                    <td>{{ec.electricalCurrentType}}</td>
                    <td style="text-align:right;padding-right:5px;">{{ec.lengthKm}}</td>
                    <td style="text-align:right;padding-right:5px;">{{ec.voltageKv}}</td>
                    <td>
                        <span *ngIf="ec.isOnshore">onshore</span>
                        <span *ngIf="ec.isOnshore && ec.isOffshore"> and </span>
                        <span *ngIf="ec.isOffshore">offshore</span>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>